import { ComponentProps, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import CarbonDotMark from '~icons/carbon/dot-mark';

type Props = ComponentProps<'div'> & {
  title?: string
  contentClassName?: string
  rightContent?: ReactNode
  /** Larger spacing and title for dense forms (e.g. bill form for readability) */
  density?: 'default' | 'comfortable'
}

export const FormSection = ({
  className,
  children,
  title,
  contentClassName,
  rightContent,
  density = 'default',
  ...props
}: Props) => {
  const comfortable = density === 'comfortable'
  return (
    <div
      className={cn('rounded-lg overflow-hidden bg-b-secondary backdrop-blur-sm', className)}
      {...props}
    >
      {title && (
        <div
          className={cn(
            'py-4 px-4 flex items-center gap-2 justify-between',
            comfortable && 'py-5 px-5 md:py-6 md:px-6',
          )}
        >
          <div
            className={cn(
              'flex items-center gap-2 text-h6-bold',
              comfortable && 'text-lg md:text-xl font-bold gap-3',
            )}
          >
            <CarbonDotMark className={cn('size-8 text-s-brand-primary', comfortable && 'size-9 md:size-10')} />
            <span>{title}</span>
          </div>
          {rightContent}
        </div>
      )}
      <div
        className={cn(
          'bg-b-secondary backdrop-blur-sm p-8 space-y-4',
          comfortable && 'space-y-6 p-6 md:p-10',
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  )
}
